import dynamic from 'next/dynamic'
import { ZoningIcon } from 'src/components/insights/icons/zoning'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import preview from 'src/assets/images/widgets-previews/zoning-details.png'

const ZoningDetails = dynamic(() => import('src/components/insights/zoning/details'), { ssr: false })

export const ZoningDetailsWidget: InsightBuilderWidget = {
  id: 'zoning-details',
  name: 'Zoning Details',
  type: 'Zoning',
  icon: ZoningIcon,
  component: ZoningDetails,
  supportedResultTypes: ['alphamap-location'],
  preview,
  minTier: 'intermediate',
}
